import { render, staticRenderFns } from "./ScanFile.vue?vue&type=template&id=4f1865ea&scoped=true"
import script from "./ScanFile.vue?vue&type=script&lang=js"
export * from "./ScanFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1865ea",
  null
  
)

export default component.exports